<template>

	<div class="dashboard login">

		<p>&nbsp;</p>
		<p>&nbsp;</p>
		<p>&nbsp;</p>

		<div class="box transition-fadeinup">

			<h2>Please sign in</h2>
			<form>
				<ul class="clearfix">
					<div class="error-messages">
						<p class="error" :class="{ 'hidden' : !error }">Username and / or password does not match.</p>
					</div>
					<li class="required">
						<label>Username</label>
						<input type="email" name="email" v-model="username">
					</li>
					<li class="required">
						<label>Password</label>
						<input type="password" v-model="password">
					</li>
					<!-- <li class="required">
						<label>Personal Showpad token</label>
						<input type="text" value="FgHFd|h44khjFGIk-UyhDGvfugkjd4bfd">
					</li> -->
					<li>
						<button type="submit" class="btn" v-on:click="loginClickHandler">Login</button>
					</li>
				</ul>
			</form>

		</div>

	</div>

</template>

<script>

export default {
	name: 'login',

	data () {
		return {
			username: null,
			password: null,
			error: false
		}
	},

	mounted () {
		this.loginBox = this.$el.querySelector('.box')
	},

	methods: {
		loginClickHandler (e) {
			e.preventDefault()

			var user = {
				'username': this.username,
				'password': this.password
			}

			user = JSON.stringify(user)

			this.setLoader()

			this.$store.dispatch('login', user).then(() => {
				this.$router.push({ path: '/dashboard' }, onComplete => {}, onAbort => { })
				this.removeLoader()
			}).catch(() => {
				this.error = true
				this.removeLoader()
			})
		},

		setLoader () {
			this.loginBox.classList.add('loading')
		},

		removeLoader () {
			this.loginBox.classList.remove('loading')
		}
	}
}
</script>
